import React from "react";
import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./routes";
import ScrollToTop from "./components/ScrollToTop";
import CookiePopup from "./components/CookiePopup";
import { AuthProvider } from "./contexts/AuthContext";
import "./index.css";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ScrollToTop />
        <CookiePopup />
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
